import React, { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { ListItem } from '@swyftx/aviary/atoms/List';
import { Modal } from '@swyftx/aviary/atoms/Modal';
import { Body } from '@swyftx/aviary/atoms/Typography';

import { Links } from '@shared/constants';

const MarginLegalInformationModal: React.FC<PropsWithChildren<unknown>> = ({ children }) => {
  const { t } = useTranslation('margin');

  return (
    <Modal
      triggerElement={<div>{children}</div>}
      title='Legal information'
      position='dynamic'
      className='lg:min-w-[400px]'
      blockOverlayClose={false}
    >
      <FlexLayout direction='column' className='px-12 pb-12' spacing={4}>
        <ListItem onClick={() => window.open(Links.legal.legal, '_blank')}>
          <FlexLayout alignItems='center' spacing={8} justifyContent='space-between' className='w-full'>
            <FlexLayout alignItems='center' spacing={8}>
              <FlexLayout direction='column' alignItems='start'>
                <Body className='break-all' color='primary'>
                  {t('profile.legal.legalInformation')}
                </Body>
              </FlexLayout>
            </FlexLayout>
          </FlexLayout>
        </ListItem>

        <ListItem onClick={() => window.open(Links.legal.tos, '_blank')}>
          <FlexLayout alignItems='center' spacing={8} justifyContent='space-between' className='w-full'>
            <FlexLayout alignItems='center' spacing={8}>
              <FlexLayout direction='column' alignItems='start'>
                <Body className='break-all' color='primary'>
                  {t('profile.legal.terms')}
                </Body>
              </FlexLayout>
            </FlexLayout>
          </FlexLayout>
        </ListItem>

        <ListItem onClick={() => window.open(Links.legal.privacyPolicy, '_blank')}>
          <FlexLayout alignItems='center' spacing={8} justifyContent='space-between' className='w-full'>
            <FlexLayout alignItems='center' spacing={8}>
              <FlexLayout direction='column' alignItems='start'>
                <Body className='break-all' color='primary'>
                  {t('profile.legal.privacyPolicy')}
                </Body>
              </FlexLayout>
            </FlexLayout>
          </FlexLayout>
        </ListItem>
      </FlexLayout>
    </Modal>
  );
};

export { MarginLegalInformationModal };
